import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Dropdown, Modal } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import MyApplicationModal from "./MyApplicationModal";

const MyApplications = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [applications, setApplications] = useState([]);
  const [rowcount, setRowcount] = useState(0);
  const [activeApplRecord, setActiveApplRecord] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [journey, setJourney] = useState([]);
  //
  const [editData, setEditData] = useState({});
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [emiData, setEmiData] = useState([]);
  const emiColumns = [
    {
      dataIndex: "emiSequence",
      title: "Seq.",
    },
    {
      dataIndex: "emiRepaymentDate",
      title: "Payment Date",
      render: (text, record) => {
        if (record?.emiRepaymentDate) {
          let date = new Date(record?.emiRepaymentDate).dateToDDMMYYYY(
            new Date(record?.emiRepaymentDate)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "outstandingAmt",
      title: "Principal Outstanding",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "emiAmt",
      title: "EMI Amount",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "principalAmt",
      title: "Principal",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "interestAmt",
      title: "Interest",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
  ];
  //
  const columns = [
    {
      dataIndex: "applicationId",
      title: "Application ID",
      render: (text, record) => {
        return (
          <>
            <div>
              <h6
                className="text-primary fw-bold cursor_pointer"
                onClick={(...args) => handleShow(...args, record)}
              >
                {props?.$store?.user?.customerName}
              </h6>
              <span className="text-primary">{text || "-"}</span>
            </div>
          </>
        );
      },
    },
    {
      dataIndex: "loanAmount",
      title: "Loan Amount",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "sanctionedLoanAmt",
      title: "Sanctioned Loan Amount",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "sanctionedTenure",
      title: "Sanctioned Tenure",
      render: (text, record) => {
        return <span>{text ? `${text} Days` : "N/A"}</span>;
      },
    },
    {
      dataIndex: "createdAt",
      title: "Applied On",
      render: (text, record) => {
        if (record?.createdAt) {
          let date = new Date(record?.createdAt).dateToDDMMYYYY(
            new Date(record?.createdAt)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text, record) => {
        let status = record?.status || "pending";
        let mappedStatus = _enum.STATUS_COLOR_MAP[status?.toLowerCase()] || "";

        return (
          <Dropdown className="status-dropdown pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              {status?.toTitleCase()}
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = (e, record) => {
    console.log({ record });
    setActiveApplRecord(record);
    setShow(true);
    // getJourney(record.applicationId);
  };

  const getApplications = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["page", "limit"]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
      console.log({ defaultSearchData: payload });
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis.apiGetCustomerApplications(payload).then(({ data, total }) => {
      setApplications(data);
      setRowcount(total);
      setIsFetching(false);
    });
  };

  const getJourney = (applicationId) => {
    props.apis
      .apiGetCustomerApplicationJourney({ applicationId: applicationId })
      .then((res) => {
        setJourney([...res]?.reverse());
        // let mokeres = [
        //   { status: "PENDING", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "APPLIED", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "UNDER_WRITING", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "SANCTIONED", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "POST_SANCTIONED", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "APPROVED", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "PRE_DISBURSEMENT", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "DISBURSED", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "REJECTED", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "QUERY", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "AGREEMENT", createdAt: "2024-05-15T10:40:22.833Z" },
        //   { status: "ESIGNED", createdAt: "2024-05-15T10:40:22.833Z" },
        // ];
        // setJourney([
        //   {
        //     status: "ACTIVE",
        //     createdAt: "2024-05-15T10:40:22.833Z",
        //   },
        //   {
        //     status: "PENDING",
        //     createdAt: "2024-05-15T10:40:22.833Z",
        //   },
        // ]);
      });
  };

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 10,
    });
  };

  const viewApplication = (record) => {
    console.log({ record });
    navigate(`/app/myapplicationview?id=${record.applicationId}`);
  };

  const editApplication = (record) => {
    navigate(`/app/loancalculationdocs?id=${record.applicationId}&path=myapplications`);
  }

  const handleCustomerApplRejection = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let urldata = {
      applicationId: activeApplRecord?.applicationId,
    };
    console.log({ urldata });

    swal2
      .fire({
        title: "Reason for rejection",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
          name: "rejectedReason",
          required: true,
        },
        showCancelButton: true,
        confirmButtonText: "Reject",
        showLoaderOnConfirm: true,
        inputValidator: (value) => {
          if (!value) {
            return "Reason for rejection is required";
          }
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          let payload = {
            rejectedReason: result.value,
          };
          console.log({ payload });

          let urldata = {
            applicationId: activeApplRecord?.applicationId,
          };

          props.apis
            .apiCustomerRejectSanctionedApplication(payload, urldata)
            .then((res) => {
              swal2.fire({
                text: "Application Rejected successfully !!",
                icon: "success",
                iconColor: "#FF4D4D",
                timer: 4000,
              });
              handleClose();
              getApplications();
            });
        }
      });
  };

  const handleCustomerApplView = () => {
    setEditmode(false);
    setViewmode(true);
    // console.log({ activeApplRecord });

    // GET APPLICATION BY ID
    props.apis
      .apiGetCustomerSingleApplication({
        applicationId: activeApplRecord?.applicationId,
      })
      .then((data) => {
        // console.log({ apiGetApplicationById: data });
        handleClose();
        let filteredData = {
          product_type: data?.sanctionedRepayType,
          ...(data?.sanctionedRepayType === "EMI"
            ? {
              no_of_emis: data?.sanctionedNoOfMonth,
            }
            : {}),
          final_loan_amount: data?.sanctionedLoanAmt,
          loan_start_date: data?.sanctionedLoanStartDate
            ? new Date(data?.sanctionedLoanStartDate).dateToDDMMYYYY(
              new Date(data?.sanctionedLoanStartDate)
            )
            : "",
          ...(data?.sanctionedRepayType === "EMI"
            ? {
              emi_start_date: data?.sanctionedEMIDate
                ? new Date(data?.sanctionedEMIDate).dateToDDMMYYYY(
                  new Date(data?.sanctionedEMIDate)
                )
                : "",
            }
            : {}),
          final_tenure: data?.sanctionedTenure,
        };

        setPopupdata(filteredData);
        setEditData(data);
        setEmiData(data?.emiSchedules || []);
        // setEmiData([
        //   {
        //     emiNumber: 1,
        //     date: new Date().dateToDDMMYYYY(new Date()),
        //     outstanding: 1234,
        //     emi: 1234,
        //     principal: 1234,
        //     interest: 1234,
        //   },
        // ]);
        openModal();
      });
  };

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const onModalClose = () => {
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    closeModal();
  };

  const handleCustomerApplAccept = () => {
    navigate(
      `/app/customerpostsanctiondocs?id=${activeApplRecord?.applicationId}`
    );
  };

  useEffect(() => {
    console.log({ activeApplRecord });
    if (activeApplRecord) {
      getJourney(activeApplRecord?.applicationId);
    }
  }, [activeApplRecord]);

  useEffect(() => {
    getApplications();
  }, [search]);
  return (
    <div>
      <MainPagetitle
        mainTitle="My Application"
        pageTitle={"My Application"}
        parentTitle={"Home"}
        pageIcon={imagepaths.greyUserCheckIconActive}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption-container">
                  <h4 className="heading mb-0">Application Status</h4>
                </div>
                <AppTable
                  data={applications}
                  total={rowcount}
                  onChange={(...arg) => onPageChange(...arg)}
                  columns={columns}
                  reorder={true}
                  viewAction={(...args) => viewApplication(...args)}
                  editAction={(...args) => editApplication(...args)}
                  deletable={false}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MyApplicationModal
        id="applicationCanvas"
        title={`${editmode
          ? "Edit Application"
          : viewmode
            ? "View Details"
            : "Add Application"
          }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        handleCustomerApplRejection={handleCustomerApplRejection}
        handleCustomerApplAccept={handleCustomerApplAccept}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        emiData={emiData}
        emiColumns={emiColumns}
        showLogsTable={viewmode}
        // onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Add"}`}
        disableallfields={viewmode ? true : false}
      />

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="application_status_modal"
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="heading_title">
            My Application Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className={Object.className({
              "decision_container mb-4": true,
              "d-none":
                activeApplRecord?.status !==
                _enum.CUSTOMER_APPLICATION_STATUS_MAP.SANCTIONED,
            })}
          >
            <img src={imagepaths.applStatusImg} alt="loan image" />
            <div className="content_box">
              <div className="details">
                <p>
                  Loan applied for Rs.{" "}
                  <span>{activeApplRecord?.loanAmount?.cur()}</span>
                </p>
                <p className="text-primary">
                  Got Recommendation of Rs.{" "}
                  <span>{activeApplRecord?.sanctionedLoanAmt?.cur()}</span>
                </p>
              </div>
              <div className="footer_details">
                <p className="me-3">
                  Tenure: <span>{activeApplRecord?.sanctionedTenure} Days</span>
                </p>
                <p>
                  ROI: <span>{activeApplRecord?.sanctionedIRR} %</span>
                </p>
              </div>
              <div className="nav_container justify-content-start">
                <a
                  href="javascript:void(0)"
                  className="me-3 text-primary text-decoration-underline fs-4"
                  onClick={(...args) => handleCustomerApplView(...args)}
                >
                  View Details
                </a>
                <button
                  type="button"
                  className="btn btn-lg btn-primary-lite me-3"
                  onClick={(...args) => handleCustomerApplRejection(...args)}
                >
                  Reject
                </button>
                <button
                  type="button"
                  className="btn btn-lg btn-primary"
                  onClick={(...args) => handleCustomerApplAccept(...args)}
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
          <div class="timeline-container">
            <ul class="tl">
              {journey.map((mile) => (
                <li className="tl-item done">
                  <div className="item-icon"></div>
                  <div className="item-text">
                    {mile?.status === "QUERY" && (
                      <button
                        type="button"
                        className="link-btn"
                        onClick={(...args) =>
                          navigate(
                            `/app/myapplicationqueries?id=${activeApplRecord?.applicationId}`
                          )
                        }
                      >
                        <span className="me-2">
                          <i className="fa-solid fa-circle"></i>
                        </span>
                        Query raised by underwriter
                      </button>
                    )}
                    <div className="item-title">{mile?.status}</div>
                    <div className="item-detail">
                      {moment(mile.createdAt).format("DD-MM-YY hh:mm a")}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default constore(MyApplications);
